
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.8065 7.52667C11.7445 7.46418 11.6708 7.41459 11.5895 7.38074C11.5083 7.34689 11.4211 7.32947 11.3331 7.32947C11.2451 7.32947 11.158 7.34689 11.0767 7.38074C10.9955 7.41459 10.9218 7.46418 10.8598 7.52667L8.66646 9.72667V4.66667C8.66646 4.48986 8.59623 4.32029 8.4712 4.19526C8.34618 4.07024 8.17661 4 7.9998 4C7.82299 4 7.65342 4.07024 7.52839 4.19526C7.40337 4.32029 7.33313 4.48986 7.33313 4.66667V9.72667L5.1398 7.52667C5.01426 7.40113 4.844 7.33061 4.66646 7.33061C4.48893 7.33061 4.31867 7.40113 4.19313 7.52667C4.0676 7.6522 3.99707 7.82247 3.99707 8C3.99707 8.17753 4.0676 8.3478 4.19313 8.47333L7.52646 11.8067C7.58987 11.8674 7.66463 11.9149 7.74646 11.9467C7.82626 11.9819 7.91255 12.0002 7.9998 12.0002C8.08704 12.0002 8.17333 11.9819 8.25313 11.9467C8.33497 11.9149 8.40973 11.8674 8.47313 11.8067L11.8065 8.47333C11.8689 8.41136 11.9185 8.33762 11.9524 8.25638C11.9862 8.17515 12.0037 8.08801 12.0037 8C12.0037 7.91199 11.9862 7.82486 11.9524 7.74362C11.9185 7.66238 11.8689 7.58864 11.8065 7.52667Z","fill":"currentColor"}})])
          )
        }
      }
    